import { render, staticRenderFns } from "./TextPanelToken.vue?vue&type=template&id=1c74e461&scoped=true&"
import script from "./TextPanelToken.vue?vue&type=script&lang=js&"
export * from "./TextPanelToken.vue?vue&type=script&lang=js&"
import style0 from "./TextPanelToken.vue?vue&type=style&index=0&id=1c74e461&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../abbreviation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c74e461",
  null
  
)

export default component.exports